import { render, staticRenderFns } from "./ShopReviewView.vue?vue&type=template&id=e57458a6&scoped=true&"
import script from "./ShopReviewView.vue?vue&type=script&lang=js&"
export * from "./ShopReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57458a6",
  null
  
)

export default component.exports